import { render, staticRenderFns } from "./awardBenefits.vue?vue&type=template&id=03167f34&scoped=true"
import script from "./awardBenefits.vue?vue&type=script&lang=js"
export * from "./awardBenefits.vue?vue&type=script&lang=js"
import style0 from "./awardBenefits.vue?vue&type=style&index=0&id=03167f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03167f34",
  null
  
)

export default component.exports